import { Card } from "@/components/ui/card";
import { Ear, Target, ImagePlus, Files } from "lucide-react";

const features = [
  {
    icon: Ear,
    title: "Accessible Alt Text Generation",
    description: "Create meaningful alt text that makes your images accessible to everyone, including screen reader users."
  },
  {
    icon: Target,
    title: "SEO Optimization",
    description: "Generate SEO-friendly alt tags that help your images rank higher in search results."
  },
  {
    icon: ImagePlus,
    title: "Bulk Image Processing",
    description: "Process multiple images at once to generate alt text and descriptions efficiently."
  },
  {
    icon: Files,
    title: "Comprehensive Image Descriptions",
    description: "Get detailed, context-aware image descriptions that enhance both accessibility and SEO."
  }
];

export const Features = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12 text-sage-800">
          Key Features
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <Card key={index} className="p-6 hover-scale glass-card">
              <div className="h-12 w-12 rounded-lg bg-sage-100 flex items-center justify-center text-sage-600 mb-4">
                <feature.icon className="w-6 h-6" />
              </div>
              <h3 className="font-semibold text-xl mb-2 text-sage-800">{feature.title}</h3>
              <p className="text-sage-600">{feature.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};